import React from 'react';
import Swal from 'sweetalert2'
import toast from "react-hot-toast";
import { sendTicket } from "../../../services/adminServices";
import { useParams } from 'react-router-dom';

const ExpertMessage = () => {
  const {id} = useParams()
  
  const sendMessage = async () => {
    try {
        const title = document.getElementById("title").value;
        const content = document.getElementById("content").value;
        if (title && content) {
          let sendData = {
            title,
            content,
            userId:id,
            target: 'Expert'
          };
          Swal.fire({
            title: 'لطفا منتظر بمانید',
            didOpen: () => { Swal.showLoading() },
          })
          const { data } = await sendTicket(sendData);
          let text = data.result_message
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: `${text}`,
            showConfirmButton: false,
            timer: 2000
          })
          document.getElementById("title").value = ''
          document.getElementById("content").value = ''
        } else {
          toast.error("عنوان یا متن پیام نمی تواند خالی باشد");
        }
    } catch (err) {
      console.log(err);
      toast.error('درخواست شما نجام نشد لطفا مجددا امتحان کنید');
      Swal.close()
    }
  };
    return (
        <div className="px-5 py-3">
      <div
        className="p-3 p-lg-5 text-end"
        style={{
          border: "1px solid #fff",
          borderRadius: "20px",
          backgroundColor: "rgba(255, 255, 255, 0.50)",
        }}
      >
        <div className='mb-3'>
        <label>عنوان پیام : </label>
        <input
        id="title"
        className="message-support-input w-100 mt-3"
        style={{ height: "50px" }}
      />
        </div>
        <div className='mb-3'>
        <label>متن پیام : </label>
        <textarea
        id="content"
        className="message-support-input w-100 mt-3"
        style={{ height: "120px", resize:"none" }}
      />
        </div>
        <div className=" text-center m-auto mt-3">
        <button
        className="btn"
        style={{
          width:"200px",
          backgroundColor: "#6BBA81",
          borderRadius: "20px",
        }}
              onClick={() => {
            sendMessage();
          }}
      >
        ارسال
      </button>
      </div>
      </div>
    </div>
    );
};

export default ExpertMessage;